<template src="./register-account.html"></template>

<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from '@/mixins/validation'
import { mask } from 'vue-the-mask'
import ContextPage from '@/components/context-page/ContextPage'
import Moment from 'moment'

Vue.use(Vuelidate)

export default {
  name: 'register-account',
  components: { ContextPage },
  mixins: [validationMixin],
  directives: { mask },
  data () {
    return {
      loading: false,
      menu: false,
      dialog: false,
      confirmationDialog: false,
      agreementConfirmation: false,
      banks: Vue.$config.banks,
      bankName: '',
      identificationNumberMask: '#########',
      uniqueIdentificationNumberMask: '#############',
      registerAccount: {
        uniqueIdentificationNumber: '',
        identificationNumber: '',
        bank: '',
        formattedDateOfBirth: ''
      },
      nameMask: {
        mask: 'CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC',
        tokens: {
          C: {
            pattern: /[a-zA-ZабвгдђежзијклљмнњопрстћуфхцчџшАБВГДЂЕЖЗИЈКЛЉМНЊОПРСТЋУФХЦЧЏШčćšđžČĆŠĐŽ\-\s]/
          }
        }
      },
      showInstanceLink: Vue.$config.service_config[Vue.$config.service_name].showInstanceLink,
      instanceLink: Vue.$config.service_config[Vue.$config.service_name].instanceLink,
      headline: Vue.$config.service_config[Vue.$config.service_name].headline,
      subHeadline: Vue.$config.service_config[Vue.$config.service_name].subHeadline,
      registrationStartDate: Vue.$config.service_config[Vue.$config.service_name].registrationStartDate,
      registrationEndDate: Vue.$config.service_config[Vue.$config.service_name].registrationEndDate
    }
  },
  computed: {
    registrationEnabled () {
      const now = Moment()
      return now > Moment(this.registrationStartDate) && now < Moment(this.registrationEndDate)
    },
    uniqueIdentificationNumberErrors () {
      return this.getValidationErrorsByName('uniqueIdentificationNumber')
    },
    identificationNumberErrors () {
      return this.getValidationErrorsByName('identificationNumber')
    },
    bankErrors () {
      return this.getValidationErrorsByName('bank')
    }
  },
  methods: {
    gotoInstance () {
      window.open(this.instanceLink + 'provera', '_blank')
    },
    home () {
      this.$router.push({ name: 'StartPage' })
    },
    validateBeforeSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.banks.forEach(function (bank) {
        if (bank.bankId === this.registerAccount.bank) {
          this.bankName = bank.bankName
        }
      }, this)
      this.dialog = true
    },
    submitAccount () {
      this.dialog = false
      this.loading = true
      this.$http.post(Vue.$apiConfig.registerAnonymousUserPost, this.registerAccount).then(
        response => {
          this.loading = false
          this.logConsole(response)
          this.clearRegisterModelData()
          this.confirmationDialog = true
        },
        error => {
          this.loading = false
          this.formatErrorResponse(error)
        })
    },
    closeConfirmationDialog () {
      this.confirmationDialog = false
      this.$router.push('/')
    },
    getValidationErrorsByName (name) {
      if (!this.$v.registerAccount[name].$dirty) return []
      return this.getValidationErrors('registerAccount').filter((x) => { return x.field === name }).map(x => x.msg)
    },
    clearRegisterModelData () {
      this.registerAccount.identificationNumber = ''
      this.registerAccount.uniqueIdentificationNumber = ''
      this.registerAccount.bank = ''
      this.$v.$reset()
    }
  },
  validations () {
    const rules = {}

    Object.assign(rules, {
      uniqueIdentificationNumber: {
        required,
        minLength: minLength(13),
        maxLength: maxLength(13)
      },
      identificationNumber: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9)
      },
      bank: {
        required
      }
    })

    return {
      registerAccount: rules
    }
  }
}
</script>

<style lang="scss">
  .header-row {
    .treasury-logo {
      background-color: transparent;
    }
  }
  .header-image {
    vertical-align: middle;
    height: 30px;
  }
  .v-card__title.account-page-title {
    padding-top: 0;
  }
</style>

<style lang="scss" scoped>
h4 {
  margin-top: 20px;
  margin-bottom: 20px;
}

.blue-text {
  color: #1c558a;
}

.background-fill {
  background-image: linear-gradient(135deg, #c9233c 10%, #063f7b 100%);
}

  .second-header-part {
    background-image: linear-gradient(90deg, #19437b 40%, #0f2542 100%);
  }
.agreement-container {
  height: 120px;
  overflow-y: scroll;
  overflow-x:hidden;
}

.disabled-button {
  background-color:red !important;
}
</style>
